<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import i18n from '../i18n';
import store from '../store';
import { log } from '../log';

export default {
  i18n,
  store,
  name: 'WanIpCheck',
  props: {
    phpWanIp: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['wanip', 'site']),
    ...mapGetters(['isRemoteAccess']),
    loading() { return !(this.wanip); },
  },
  methods: {
    ...mapActions(['getWanIp']),
  },
  created() {
    log.debug('[🍣 WanIpCheck 🍣]');
    if (!this.wanip) this.getWanIp();
  },
};
</script>

<template>
  <transition appear name="fade" mode="out-in">
    <span v-if="loading" v-html="`${$t('wanIpCheck.checking')}…`"></span>
    <template v-else>
      <span v-if="!phpWanIp" class="error" v-html="$t('wanIpCheck.resolveError')"></span>
      <template v-else>
        <span v-if="isRemoteAccess" v-html="$t('wanIpCheck.match', [phpWanIp])"></span>
        <span v-else-if="phpWanIp === wanip && !isRemoteAccess" v-html="$t('wanIpCheck.match', [wanip])"></span>
        <span v-else v-html="$t('wanIpCheck.mismatch', [phpWanIp, wanip])" class="mismatch"></span>
      </template>
    </template>
  </transition>
</template>

<style lang="postcss" scoped>
.mismatch {
  display: inline-block;
  width: 50%;
  white-space: normal;
}

.error {
  color: #E22828;
  font-weight: 600;
}
</style>
